import React from "react";
import cogoToast from "cogo-toast";
import { useState, useEffect } from "react";
import {
  createStaffFileTypeApi,
  listStaffFileTypesApi,
  getStaffFileTypeDetailsApi,
  updateStaffFileTypeApi,
  deleteStaffFileTypeApi,
} from "../../services/Api";
import { SUCCESS_RESULT } from "../../Constants";
import { FaTimes, FaEdit, FaPlus, FaTrash, FaSearch, FaInfoCircle } from "react-icons/fa";
import { useHistory } from "react-router-dom";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Card,
  CardBody,
  CardHeader,
  Table,
  Input,
  Form,
  FormGroup,
  Label,
  Row,
  Col,
  Badge,
} from "reactstrap";
import BtnSpinner from "../../components/BtnSpinner";
import Swal from "sweetalert2";

const StaffFileTypes = (props) => {
  const history = useHistory();
  const [is_processing, setProcessing] = useState(false);
  const [rowData, setRowData] = useState([]);
  const [creatingFileType, setCreatingFileType] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    description: "",
  });
  const [show_create_dialog, setShow_create_dialog] = useState(false);
  const [show_update_dialog, setShow_update_dialog] = useState(false);
  const [show_details_dialog, setShow_details_dialog] = useState(false);
  const [fileTypeToUpdate, setFileTypeToUpdate] = useState({});
  const [fileTypeDetails, setFileTypeDetails] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState(10001); // 10001 = Active, 10002 = Inactive

  useEffect(() => {
    fetch_file_types_list();
    return () => {};
  }, [statusFilter]);

  const create_file_type = (e) => {
    e.preventDefault();
    
    if (!formData.name || formData.name.trim() === "") {
      cogoToast.error("File type name is required", { hideAfter: 3 });
      return;
    }

    if (formData.name.length > 100) {
      cogoToast.error("File type name must not exceed 100 characters", { hideAfter: 3 });
      return;
    }

    setCreatingFileType(true);

    let data = {
      name: formData.name.trim(),
      description: formData.description ? formData.description.trim() : "",
      country_id: 2, // Default to 2
    };

    createStaffFileTypeApi(data)
      .then((res) => {
        setCreatingFileType(false);
        if (res.status === 200) {
          const response = res.data;
          if (response.status === SUCCESS_RESULT) {
            setShow_create_dialog(false);
            resetForm();
            fetch_file_types_list();
            cogoToast.success(response.message || "File type created successfully", {
              hideAfter: 3,
            });
          } else {
            cogoToast.error(response.message || "Failed to create file type", {
              hideAfter: 5,
            });
          }
        } else {
          cogoToast.error(res.message || "Failed to create file type", {
            hideAfter: 5,
          });
        }
      })
      .catch((e) => {
        setCreatingFileType(false);
        const errorMessage =
          e?.response?.data?.message || "Something went wrong, please try again.";
        cogoToast.error(errorMessage, { hideAfter: 5 });
      });
  };

  const update_file_type = (e) => {
    e.preventDefault();

    if (!fileTypeToUpdate.name || fileTypeToUpdate.name.trim() === "") {
      cogoToast.error("File type name is required", { hideAfter: 3 });
      return;
    }

    if (fileTypeToUpdate.name.length > 100) {
      cogoToast.error("File type name must not exceed 100 characters", { hideAfter: 3 });
      return;
    }

    setCreatingFileType(true);

    let data = {
      id: fileTypeToUpdate.id,
      name: fileTypeToUpdate.name.trim(),
      description: fileTypeToUpdate.description
        ? fileTypeToUpdate.description.trim()
        : "",
      status: fileTypeToUpdate.status || 10001,
    };

    updateStaffFileTypeApi(data)
      .then((res) => {
        setCreatingFileType(false);
        if (res.status === 200) {
          const response = res.data;
          if (response.status === SUCCESS_RESULT) {
            setShow_update_dialog(false);
            setFileTypeToUpdate({});
            fetch_file_types_list();
            cogoToast.success(response.message || "File type updated successfully", {
              hideAfter: 3,
            });
          } else {
            cogoToast.error(response.message || "Failed to update file type", {
              hideAfter: 5,
            });
          }
        } else {
          cogoToast.error(res.message || "Failed to update file type", {
            hideAfter: 5,
          });
        }
      })
      .catch((e) => {
        setCreatingFileType(false);
        const errorMessage =
          e?.response?.data?.message || "Something went wrong, please try again.";
        cogoToast.error(errorMessage, { hideAfter: 5 });
      });
  };

  const fetch_file_types_list = () => {
    setProcessing(true);

    const payload = {
      status: statusFilter,
    };

    listStaffFileTypesApi(payload)
      .then((res) => {
        setProcessing(false);
        if (res.status === 200) {
          const response = res.data;
          if (response.status === SUCCESS_RESULT) {
            setRowData(response.data || []);
          } else {
            cogoToast.error(response.message || "Failed to load file types", {
              hideAfter: 5,
            });
            setRowData([]);
          }
        } else {
          cogoToast.error(res.message || "Failed to load file types", {
            hideAfter: 5,
          });
          setRowData([]);
        }
      })
      .catch((err) => {
        setProcessing(false);
        cogoToast.error("Something went wrong, please try again.", {
          hideAfter: 5,
        });
        setRowData([]);
      });
  };

  const handleDelete = (fileType) => {
    Swal.fire({
      title: "Delete File Type?",
      text: `Are you sure you want to delete "${fileType.name}"? This will set it to inactive.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Delete!",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: "Processing..",
          html: "Please wait...",
          timerProgressBar: true,
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
            deleteStaffFileTypeApi({
              id: fileType.id,
            })
              .then((res) => {
                Swal.close();
                if (res.status === 200) {
                  const response = res.data;
                  if (response.status === SUCCESS_RESULT) {
                    fetch_file_types_list();
                    cogoToast.success(
                      response.message || "File type deleted successfully",
                      {
                        hideAfter: 3,
                      }
                    );
                  } else {
                    cogoToast.error(response.message || "Failed to delete file type", {
                      hideAfter: 5,
                    });
                  }
                } else {
                  cogoToast.error(res.message || "Failed to delete file type", {
                    hideAfter: 5,
                  });
                }
              })
              .catch((e) => {
                Swal.close();
                const errorMessage =
                  e?.response?.data?.message || "Cannot delete file type";
                cogoToast.error(errorMessage, {
                  hideAfter: 5,
                });
              });
          },
        });
      }
    });
  };

  const handleEdit = (fileType) => {
    setFileTypeToUpdate({
      id: fileType.id,
      name: fileType.name,
      description: fileType.description || "",
      status: fileType.status,
    });
    setShow_update_dialog(true);
  };

  const handleViewDetails = (fileType) => {
    setProcessing(true);
    getStaffFileTypeDetailsApi({ id: fileType.id })
      .then((res) => {
        setProcessing(false);
        if (res.status === 200) {
          const response = res.data;
          if (response.status === SUCCESS_RESULT) {
            setFileTypeDetails(response.data);
            setShow_details_dialog(true);
          } else {
            cogoToast.error(response.message || "Failed to load file type details", {
              hideAfter: 5,
            });
          }
        } else {
          cogoToast.error(res.message || "Failed to load file type details", {
            hideAfter: 5,
          });
        }
      })
      .catch((err) => {
        setProcessing(false);
        cogoToast.error("Something went wrong, please try again.", {
          hideAfter: 5,
        });
      });
  };

  const resetForm = () => {
    setFormData({
      name: "",
      description: "",
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleUpdateInputChange = (e) => {
    const { name, value } = e.target;
    setFileTypeToUpdate((prev) => ({
      ...prev,
      [name]: name === "status" ? parseInt(value) : value,
    }));
  };

  // Filter data based on search term
  const filteredData = rowData.filter((item) =>
    item.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.description?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.country?.country_name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Format date
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    try {
      const date = new Date(dateString);
      return date.toLocaleString();
    } catch (e) {
      return dateString;
    }
  };

  return (
    <div>
      <div className="page-header d-print-none mb-4">
        <div className="container-xl">
          <div className="row g-2 align-items-center">
            <div className="col">
              <h2 className="page-title">Staff File Types Management</h2>
              <div className="text-muted mt-1">
                Create, view, update, and manage staff file types
              </div>
            </div>
            <div className="col-auto ms-auto">
              <Button
                color="primary"
                onClick={() => setShow_create_dialog(true)}
                style={{
                  background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                  border: "none",
                }}
              >
                <FaPlus /> Create File Type
              </Button>
            </div>
          </div>
        </div>
      </div>

      <div className="container-xl">
        <Card className="shadow-sm">
          <CardHeader>
            <Row>
              <Col md={6}>
                <div className="input-group">
                  <span className="input-group-text">
                    <FaSearch />
                  </span>
                  <Input
                    type="text"
                    placeholder="Search file types..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>
              </Col>
              <Col md={3}>
                <Input
                  type="select"
                  value={statusFilter}
                  onChange={(e) => setStatusFilter(parseInt(e.target.value))}
                >
                  <option value={10001}>Active Only</option>
                  <option value={10002}>Inactive Only</option>
                </Input>
              </Col>
              <Col md={3} className="text-end">
                <Button
                  color="secondary"
                  outline
                  onClick={fetch_file_types_list}
                  disabled={is_processing}
                >
                  {is_processing ? "Loading..." : "Refresh"}
                </Button>
              </Col>
            </Row>
          </CardHeader>
          <CardBody>
            {is_processing && filteredData.length === 0 ? (
              <div className="text-center py-5">
                <BtnSpinner
                  is_loading={true}
                  text="Loading file types..."
                  color="primary"
                />
              </div>
            ) : filteredData.length === 0 ? (
              <div className="text-center py-5">
                <p className="text-muted">No file types found</p>
              </div>
            ) : (
              <div className="table-responsive">
                <Table hover striped>
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Description</th>
                      <th>Status</th>
                      <th>Created By</th>
                      <th>Created At</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredData.map((fileType) => (
                      <tr key={fileType.id}>
                        <td>
                          <strong>{fileType.name}</strong>
                        </td>
                        <td>{fileType.description || "N/A"}</td>
                        <td>
                          <Badge
                            color={fileType.status === 10001 ? "success" : "secondary"}
                          >
                            {fileType.status === 10001 ? "Active" : "Inactive"}
                          </Badge>
                        </td>
                        <td>
                          {fileType.created_by && fileType.created_by.name ? (
                            <span>{fileType.created_by.name}</span>
                          ) : (
                            "N/A"
                          )}
                        </td>
                        <td>{formatDate(fileType.created_at)}</td>
                        <td>
                          <Button
                            color="info"
                            size="sm"
                            className="me-2"
                            onClick={() => handleViewDetails(fileType)}
                            title="View Details"
                          >
                            <FaInfoCircle />
                          </Button>
                          <Button
                            color="warning"
                            size="sm"
                            className="me-2"
                            onClick={() => handleEdit(fileType)}
                            title="Edit"
                          >
                            <FaEdit />
                          </Button>
                          <Button
                            color="danger"
                            size="sm"
                            onClick={() => handleDelete(fileType)}
                            title="Delete"
                          >
                            <FaTrash />
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            )}
          </CardBody>
        </Card>
      </div>

      {/* Create Modal */}
      <Modal
        isOpen={show_create_dialog}
        toggle={() => {
          setShow_create_dialog(false);
          resetForm();
        }}
        size="lg"
      >
        <ModalHeader
          toggle={() => {
            setShow_create_dialog(false);
            resetForm();
          }}
        >
          Create New File Type
        </ModalHeader>
        <Form onSubmit={create_file_type}>
          <ModalBody>
            <FormGroup>
              <Label for="name">
                File Type Name <span className="text-danger">*</span>
              </Label>
              <Input
                type="text"
                name="name"
                id="name"
                placeholder="Enter file type name"
                value={formData.name}
                onChange={handleInputChange}
                maxLength={100}
                required
              />
              <small className="text-muted">
                Maximum 100 characters. Must be unique.
              </small>
            </FormGroup>
            <FormGroup>
              <Label for="description">Description</Label>
              <Input
                type="textarea"
                name="description"
                id="description"
                placeholder="Enter file type description (optional)"
                value={formData.description}
                onChange={handleInputChange}
                rows={4}
              />
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button
              color="secondary"
              onClick={() => {
                setShow_create_dialog(false);
                resetForm();
              }}
            >
              Cancel
            </Button>
            {creatingFileType ? (
              <BtnSpinner
                is_loading={true}
                text="Creating..."
                color="primary"
                class="btn btn-primary"
              />
            ) : (
              <Button
                color="primary"
                type="submit"
                style={{
                  background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                  border: "none",
                }}
              >
                Create File Type
              </Button>
            )}
          </ModalFooter>
        </Form>
      </Modal>

      {/* Update Modal */}
      <Modal
        isOpen={show_update_dialog}
        toggle={() => {
          setShow_update_dialog(false);
          setFileTypeToUpdate({});
        }}
        size="lg"
      >
        <ModalHeader
          toggle={() => {
            setShow_update_dialog(false);
            setFileTypeToUpdate({});
          }}
        >
          Update File Type
        </ModalHeader>
        <Form onSubmit={update_file_type}>
          <ModalBody>
            <FormGroup>
              <Label for="update_name">
                File Type Name <span className="text-danger">*</span>
              </Label>
              <Input
                type="text"
                name="name"
                id="update_name"
                placeholder="Enter file type name"
                value={fileTypeToUpdate.name || ""}
                onChange={handleUpdateInputChange}
                maxLength={100}
                required
              />
              <small className="text-muted">
                Maximum 100 characters. Must be unique.
              </small>
            </FormGroup>
            <FormGroup>
              <Label for="update_description">Description</Label>
              <Input
                type="textarea"
                name="description"
                id="update_description"
                placeholder="Enter file type description (optional)"
                value={fileTypeToUpdate.description || ""}
                onChange={handleUpdateInputChange}
                rows={4}
              />
            </FormGroup>
            <FormGroup>
              <Label for="update_status">Status</Label>
              <Input
                type="select"
                name="status"
                id="update_status"
                value={fileTypeToUpdate.status || 10001}
                onChange={handleUpdateInputChange}
              >
                <option value={10001}>Active</option>
                <option value={10002}>Inactive</option>
              </Input>
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button
              color="secondary"
              onClick={() => {
                setShow_update_dialog(false);
                setFileTypeToUpdate({});
              }}
            >
              Cancel
            </Button>
            {creatingFileType ? (
              <BtnSpinner
                is_loading={true}
                text="Updating..."
                color="primary"
                class="btn btn-primary"
              />
            ) : (
              <Button
                color="primary"
                type="submit"
                style={{
                  background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                  border: "none",
                }}
              >
                Update File Type
              </Button>
            )}
          </ModalFooter>
        </Form>
      </Modal>

      {/* Details Modal */}
      <Modal
        isOpen={show_details_dialog}
        toggle={() => {
          setShow_details_dialog(false);
          setFileTypeDetails(null);
        }}
        size="lg"
      >
        <ModalHeader
          toggle={() => {
            setShow_details_dialog(false);
            setFileTypeDetails(null);
          }}
        >
          File Type Details
        </ModalHeader>
        <ModalBody>
          {fileTypeDetails ? (
            <div>
              <Row className="mb-3">
                <Col md={6}>
                  <strong>Name:</strong>
                  <p>{fileTypeDetails.name}</p>
                </Col>
                <Col md={6}>
                  <strong>Status:</strong>
                  <p>
                    <Badge
                      color={fileTypeDetails.status === 10001 ? "success" : "secondary"}
                    >
                      {fileTypeDetails.status === 10001 ? "Active" : "Inactive"}
                    </Badge>
                  </p>
                </Col>
              </Row>
              <Row className="mb-3">
                <Col md={12}>
                  <strong>Description:</strong>
                  <p>{fileTypeDetails.description || "N/A"}</p>
                </Col>
              </Row>
              <Row className="mb-3">
                <Col md={6}>
                  <strong>Country:</strong>
                  <p>
                    {fileTypeDetails.country ? (
                      <Badge color="info">{fileTypeDetails.country.country_name}</Badge>
                    ) : (
                      <Badge color="secondary">Global</Badge>
                    )}
                  </p>
                </Col>
                <Col md={6}>
                  <strong>Files Count:</strong>
                  <p>
                    <Badge color="primary">{fileTypeDetails.files_count || 0}</Badge>
                  </p>
                </Col>
              </Row>
              <Row className="mb-3">
                <Col md={6}>
                  <strong>Created By:</strong>
                  <p>
                    {fileTypeDetails.created_by && fileTypeDetails.created_by.name
                      ? `${fileTypeDetails.created_by.name} (${fileTypeDetails.created_by.email || ""})`
                      : "N/A"}
                  </p>
                </Col>
                <Col md={6}>
                  <strong>Created At:</strong>
                  <p>{formatDate(fileTypeDetails.created_at)}</p>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <strong>Updated At:</strong>
                  <p>{formatDate(fileTypeDetails.updated_at)}</p>
                </Col>
              </Row>
            </div>
          ) : (
            <div className="text-center py-3">
              <BtnSpinner
                is_loading={true}
                text="Loading details..."
                color="primary"
              />
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <Button
            color="secondary"
            onClick={() => {
              setShow_details_dialog(false);
              setFileTypeDetails(null);
            }}
          >
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default StaffFileTypes;
